<template>
    <div>
        <div>
            <div class="flex flex-wrap space-x-2 items-center" @click="showSlideOver = true">
                <BadgePill
                    v-for="option in selectedOptions"
                    :key="option.value"
                    :title="option.text"
                    class="cursor-pointer"
                >
                    {{ option.abbreviation }}
                </BadgePill>
                <template v-if="selectedOptions.length === 0">
                    <AppButton element="button" type="button">
                        {{ $t('messages.select') }}
                    </AppButton>
                </template>
                <button type="button">
                    <svg
                        class="w-10 h-10 text-indigo-300"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                </button>
            </div>
        </div>
        <SlideOver :show="showSlideOver" @close="showSlideOver = false">
            <details v-for="optgroup in optgroups" :key="optgroup.id" :open="optgroup.open">
                <summary>
                    <span>{{ optgroup.label }}</span>
                </summary>
                <ul>
                    <li v-for="option in optgroup.options" :key="option.value">
                        <label class="ml-1 mr-3">
                            <input
                                name="options[]"
                                type="checkbox"
                                :value="option.value"
                                v-model.number="selected"
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded mr-1"
                            />
                            <span
                                class="inline-block text-sm leading-5 font-medium text-gray-700"
                                :title="option.description"
                            >
                                {{ option.abbreviation }} {{ option.text }}
                            </span>
                        </label>
                    </li>
                </ul>
            </details>

            <div>
                <slot />
            </div>
        </SlideOver>
    </div>
</template>

<script>
import BadgePill from '@/components/BadgePill.vue';
import SlideOver from '@/components/SlideOver.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    name: 'SlideOverCheckboxInputDimensions',
    components: {
        SlideOver,
        BadgePill,
        AppButton,
    },
    data() {
        return {
            selected: this.modelValue.map((v) => +v),
            showSlideOver: false,
        };
    },
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            required: true,
        },
        optgroups: {
            required: true,
            type: Array,
        },
    },
    watch: {
        selected(newVal) {
            this.$emit('update:modelValue', newVal);
        },
    },
    computed: {
        selectedOptions: function () {
            return this.optgroups.flatMap((o) => o.options).filter((s) => this.selected.includes(s.value));
        },
    },
};
</script>
